/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable consistent-return */
import ROUTES from 'modules/common/constants/route';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
/**
 * This custom hook use for handle the count down feature
 * @returns
 */
const useCounter = () => {
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState(null);
  useEffect(() => {
    if (timeLeft === 0) {
      setTimeLeft(null);
      navigate(ROUTES.LOGIN);
    }

    /* Exit early when we reach 0 */
    if (!timeLeft) return;

    /* Save intervalId to clear the interval when the
        component re-renders */
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    /* Clear interval on re-render to avoid memory leaks */
    return () => clearInterval(intervalId);
    /* Add timeLeft as a dependency to re-rerun the effect
        when we update it */
  }, [timeLeft, navigate]);
  return { timeLeft, setTimeLeft };
};
//
export default useCounter;
